// extracted by mini-css-extract-plugin
export default {"main":"Blogs_main__YXezT","inner":"Blogs_inner__reXyE","span":"Blogs_span__OCyq0","icon":"Blogs_icon__rfjHm","heading":"Blogs_heading__ywVwd"};